import { Env } from '@/Env';
import { AuthEnvironmentValueSetting } from '@/modules/auth/models/AuthEnvironmentValueSetting';
import AuthEnvironmentValuesResource from '@/modules/auth/resources/AuthEnvironmentValuesResource';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';

export class AuthEnvironmentValuesService extends BaseService {
  resource: typeof AuthEnvironmentValuesResource;

  constructor() {
    super();
    this.resource = AuthEnvironmentValuesResource;
  }

  async fetchEnvironmentValues(): Promise<void> {
    const settings: AuthEnvironmentValueSetting = await this.resource.fetchEnvironmentValues();

    Env.setEnvValues(settings.settings);
  }
}

export default new AuthEnvironmentValuesService();
